<template>
    <div class="w-100">
        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>                
            </div>
            <!-- Progress bar -->
            <div v-if="progressBar == true" class="col-3 ms-auto d-print-none d-flex align-items-center" id="progressBar">
                <span class="small me-3 w-50 text-end">{{ percentageComplete }}% Complete</span>
                <b-progress class="w-50" :value="currentStep" :max="maxStep" animated></b-progress>
               
            </div>
        </div>

        <!-- Alert box -->
        <div v-if="this.v$.step[this.currentStep].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-care-plan" action="care-plans/store" class="add-care-plan add-record">
            
            <div class="card" v-if="currentStep == 0" title="Initial Care Plan Details">
                <div class="card-header">
                    <h3 class="card-title">Initial Care Plan Details</h3>
                </div>

                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">

                            <div class="row mb-3">
                                <div class="form-label">Recording on Admission</div>   
                                <div class="col-3 form-floating">                                    
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="temp"
                                        id="temp"
                                        placeholder="Temp"
                                        v-model="step[0].temp"
                                        :class="{'is-invalid': v$.step[0].temp.$invalid}"
                                    />
                                    <label for="temp">Temp</label>
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].temp.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>                                 
                                </div>
                                <div class="col-3 form-floating">                                    
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="pulse"
                                        id="pulse"
                                        placeholder="Pulse"
                                        v-model="step[0].pulse"
                                        :class="{'is-invalid': v$.step[0].pulse.$invalid}"
                                    />
                                    <label for="pulse">Pulse</label>
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].pulse.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>                                                                     
                                </div>
                                <div class="col-3 form-floating">                                    
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="resps"
                                        id="resps"
                                        placeholder="Resps"
                                        v-model="step[0].resps"
                                        :class="{'is-invalid': v$.step[0].resps.$invalid}"
                                    />
                                    <label for="resps">Resps</label>
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].resps.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                                <div class="col-3 form-floating">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="o2sat"
                                        id="o2sat"
                                        placeholder="O2 Sat"
                                        v-model="step[0].o2sat"
                                        :class="{'is-invalid': v$.step[0].o2sat.$invalid}"
                                    />
                                    <label for="resps">O2 Sat</label>
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].o2sat.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>                         
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-3 form-floating">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="bp"
                                        id="bp"
                                        placeholder="BP"
                                        v-model="step[0].bp"
                                        :class="{'is-invalid': v$.step[0].bp.$invalid}"
                                    />
                                    <label for="bp">BP</label>
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].bp.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>                                                             
                                </div>
                                <div class="col-3 form-floating">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="weight"
                                        id="weight"
                                        placeholder="Weight"
                                        v-model="step[0].weight"
                                        :class="{'is-invalid': v$.step[0].weight.$invalid}"
                                    />
                                    <label for="weight">Weight</label>
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].weight.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>                                                                                             
                                </div>
                                <div class="col-4 form-floating">
                                    <input
                                        type="text"
                                        class="form-control w-75"
                                        name="bsl"
                                        id="bsl"
                                        placeholder="BSL (If Diabetic)"
                                        v-model="step[0].bsl"
                                        :class="{'is-invalid': v$.step[0].bsl.$invalid}"
                                    />
                                    <label for="bsl">BSL (If Diabetic)</label>
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].bsl.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>                                    
                                </div>
                                <div class="col-3">                       
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="form-label">Orientation / Mental State</div>
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.orientationMentalStateOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[0].orientationMentalState" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>  
                                </div>
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.orientationMentalStateOptions" v-if="key > 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[0].orientationMentalState" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                </div>                           
                                <div
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[0].orientationMentalState.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="form-label">Speech / Communication</div>
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.speechCommunicationOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[0].speechCommunication" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div> 
                                </div>
                                <div class="col-6">
                                    <div v-if="step[0].speechCommunication.indexOf('Other Language') !== -1" >
                                        <input
                                            type="text"
                                            class="form-control w-100"
                                            name="speechCommunicationPrimaryLanguage"
                                            placeholder="Primary language"
                                            v-model="step[0].speechCommunicationPrimaryLanguage"
                                            :class="{
                                                'is-invalid': v$.step[0].speechCommunicationPrimaryLanguage.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[0].speechCommunicationPrimaryLanguage.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>                                                              
                                    <div v-if="step[0].speechCommunication.indexOf('Other Language') !== -1" class="mt-2">
                                        <input
                                            type="text"
                                            class="form-control w-100"
                                            name="speechCommunicationSecondaryLanguage"
                                            placeholder="Secondary language"
                                            v-model="step[0].speechCommunicationSecondaryLanguage"
                                            :class="{
                                                'is-invalid': v$.step[0].speechCommunicationSecondaryLanguage.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[0].speechCommunicationSecondaryLanguage.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>

                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[0].speechCommunication.$invalid}"
                                >
                                    Invalid feedback
                                </div>

      
                            </div>

                            <div class="row mb-3">
                                <div class="form-label">Mobility / Falls Risk </div>
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.mobilityOptions" v-if="key <= 5">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[0].mobility" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>  
                                </div>
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.mobilityOptions" v-if="key > 5">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[0].mobility" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>                                    

                                    <div v-if="step[0].mobility.indexOf('Falls Risk') !== -1" class="mt-2">
                                        <select
                                            class="form-select w-100"
                                            name="fallsRisk"
                                            placeholder="Falls Risk"
                                            v-model="step[0].fallsRisk"
                                            :class="{
                                                'is-invalid': v$.step[0].fallsRisk.$invalid,
                                            }"
                                        >   
                                            <option value="" selected class="p-4 text-muted" >
                                            Falls Risk
                                            </option>
                                            <option v-for="option in fallsRiskOptions" :value="option">
                                                {{ option }}
                                            </option>
                                        </select>                                
                                        <div class="invalid-feedback" :class="{'d-block': v$.step[0].fallsRisk.$invalid}">Invalid feedback</div>    
                                    </div>
                                </div>
                      
                                <div 
                                    class="invalid-feedback col-12"
                                    :class="{'d-block': v$.step[0].mobility.$invalid}"
                                >
                                    Invalid feedback
                                </div>



                            </div>                            
                 
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">

                            <div class="row mb-3">
                                <div class="form-label">Hygiene / Dressing</div>

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.hygieneDressingOptions" v-if="key <= 4">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[0].hygieneDressing" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>

                                    <div v-if="step[0].hygieneDressing.indexOf('Shower') !== -1" class="mt-2">                                        
                                        <select
                                            class="form-select w-100"
                                            name="showerFrequency"
                                            v-model="step[0].showerFrequency"
                                            :class="{
                                                'is-invalid': v$.step[0].showerFrequency.$invalid,
                                            }"
                                        >   
                                            <option value="" selected class="p-4 text-muted" >
                                            Shower Frequency
                                            </option>
                                            <option v-for="option in fallsRiskOptions" :value="option">
                                                {{ option }}
                                            </option>
                                        </select>                                
                                        <div class="invalid-feedback" :class="{'d-block': v$.step[0].showerFrequency.$invalid}">Invalid feedback</div>    
                                    </div>
                                </div>                           

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.hygieneDressingOptions" v-if="key > 4">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[0].hygieneDressing" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>  
                                </div>                           
                                                              
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[0].hygieneDressing.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>   
                            
                            <div class="row mb-3">
                                <div class="form-label">Skin</div>

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.skinOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[0].skin" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                </div>                           

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.skinOptions" v-if="key > 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[0].skin" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>  
                                </div>                           
                                                              
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[0].skin.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn d-none">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack()" class="p-2 d-block cancel-btn">Cancel</a>
                        <a @click="onClickNext()" class="ms-2 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 1" title="Initial Care Plan Details">
                <div class="card-header">
                    <h3 class="card-title">Plan Information</h3>
                </div>

                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            
                            <div class="row mb-3">
                                <div class="form-label">Pain Management</div>

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.painManagementOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].painManagement" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                </div>                         
                                                              
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[1].painManagement.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="form-label">Pressure Injury Risk</div>

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.pressureInjuryRiskOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].pressureInjuryRisk" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                </div>                         
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.pressureInjuryRiskOptions" v-if="key > 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].pressureInjuryRisk" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>

                                    <div v-if="step[1].pressureInjuryRisk.indexOf('Regular turns') !== -1" >
                                        <input
                                            type="text"
                                            class="form-control w-100"
                                            name="turnsFrequency"
                                            placeholder="Turns frequency"
                                            v-model="step[1].turnsFrequency"
                                            :class="{
                                                'is-invalid': v$.step[1].turnsFrequency.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].turnsFrequency.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                        
                                    </div>    

                                </div>                         
                                                              
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[1].pressureInjuryRisk.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                          
                            <div class="row mb-3">
                                <div class="form-label">Mouth Cares</div>

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.mouthCaresOptions" v-if="key <= 5">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].mouthCares" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                </div>                         
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.mouthCaresOptions" v-if="key > 5">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].mouthCares" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>

                                    <div v-if="step[1].mouthCares.indexOf('Soak dentures') !== -1" >
                                        <input
                                            type="text"
                                            class="form-control w-100"
                                            name="soakDenturesFrequency"
                                            placeholder="Soak dentures frequency"
                                            v-model="step[1].soakDenturesFrequency"
                                            :class="{
                                                'is-invalid': v$.step[1].soakDenturesFrequency.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].soakDenturesFrequency.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>                         
                                                              
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[1].mouthCares.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="row mb-3">                                
                                <div class="col-6">
                                    <div class="form-label">Grooming (Fingernails)</div>
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.groomingFingernailsOptions" v-if="key <= 2">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].groomingFingernails" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                    <div 
                                        class="invalid-feedback"
                                        :class="{'d-block': v$.step[1].groomingFingernails.$invalid}"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>                         
                                <div class="col-6">
                                    <div class="form-label">Grooming (Toenails)</div>
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.groomingToenailsOptions" v-if="key <= 2">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].groomingToenails" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                    <div 
                                        class="invalid-feedback"
                                        :class="{'d-block': v$.step[1].groomingToenails.$invalid}"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                            </div>                                           

                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="row mb-3">                                
                                <div class="form-label">Grooming (Hair)</div>      
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.groomingHairOptions" v-if="key <= 5">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].groomingHair" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                </div>                         
                                <div class="col-6">
                                </div>                         
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[1].groomingHair.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="form-label">Toileting</div>

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.toiletingOptions" v-if="key <= 6">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].toileting" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>

                                    <div v-if="step[1].toileting.indexOf('Catheter (SPC / IDC)') !== -1" >
                                        <input
                                            type="text"
                                            class="form-control w-100"
                                            name="catheterEmptyingFrequency"
                                            placeholder="Frequency of emptying"
                                            v-model="step[1].catheterEmptyingFrequency"
                                            :class="{
                                                'is-invalid': v$.step[1].catheterEmptyingFrequency.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].catheterEmptyingFrequency.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>                         
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.toiletingOptions" v-if="key > 6">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].toileting" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>

                                    <div v-if="step[1].toileting.indexOf('Regular Toileting') !== -1" >
                                        <input
                                            type="text"
                                            class="form-control w-100"
                                            name="toiletingFrequency"
                                            placeholder="Toileting frequency"
                                            v-model="step[1].toiletingFrequency"
                                            :class="{
                                                'is-invalid': v$.step[1].toiletingFrequency.$invalid,
                                            }"
                                        />
                                        
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].toiletingFrequency.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>                         
                                                              
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[1].toileting.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            
                            <div class="row mb-3">
                                <div class="form-label">Sleeping</div>

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.sleepingOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].sleeping" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>

                                    <div v-if="step[1].sleeping.indexOf('Wakes') !== -1" >
                                        <input
                                            type="time"
                                            class="form-control w-75"
                                            name="wakes"
                                            placeholder="Wakes"
                                            v-model="step[1].wakes"
                                            :class="{
                                                'is-invalid': v$.step[1].wakes.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].wakes.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>                         
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.sleepingOptions" v-if="key > 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[1].sleeping" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>

                                    <div v-if="step[1].sleeping.indexOf('Settles') !== -1" >
                                        <input
                                            type="time"
                                            class="form-control w-75"
                                            name="settles"
                                            placeholder="Settles"
                                            v-model="step[1].settles"
                                            :class="{
                                                'is-invalid': v$.step[1].settles.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[1].settles.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>                         
                                                              
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[1].sleeping.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>                            

                                   
                        </div>
                    </div>
                </div>
                
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn" id="last-save-btn">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack()" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext()" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
                
            </div>

            <div class="card" v-if="currentStep == 2" title="Initial Care Plan Details">
                <div class="card-header">
                    <h3 class="card-title">Initial Care Plan Details </h3>
                </div>

                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="row mb-3">
                                <div class="form-label">Breathing / Respiratory</div>

                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.breathingRespiratoryOptions" v-if="key <= 1">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[2].breathingRespiratory" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>

                                    <div v-if="step[2].breathingRespiratory.indexOf('Some difficulty') !== -1" >
                                        <input
                                            type="text"
                                            class="form-control w-100"
                                            name="breathingDifficultyDescription"
                                            placeholder="Describe breathing difficulty"
                                            v-model="step[2].breathingDifficultyDescription"
                                            :class="{
                                                'is-invalid': v$.step[2].breathingDifficultyDescription.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[2].breathingDifficultyDescription.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>                         
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.breathingRespiratoryOptions" v-if="key > 1">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[2].breathingRespiratory" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>

                                </div>                         
                                                              
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[2].breathingRespiratory.$invalid}"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-6">
                                    <div class="form-label">Hearing</div>
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.hearingOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[2].hearing" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                    <div 
                                        class="invalid-feedback"
                                        :class="{'d-block': v$.step[2].hearing.$invalid}"
                                    >
                                        Invalid feedback
                                    </div>

                                    <div v-if="step[2].hearing.indexOf('Hearing Aid') !== -1" class="mt-2">
                                        <select
                                            class="form-select w-75"
                                            name="hearingAidPlacement"
                                            placeholder="Choose hearing aid placement"
                                            v-model="step[2].hearingAidPlacement"
                                            :class="{
                                                'is-invalid': v$.step[2].hearingAidPlacement.$invalid,
                                            }"
                                        >   
                                            <option value="" selected class="p-4 text-muted" >
                                            Choose placement
                                            </option>
                                            <option v-for="option in hearingAidPlacementOptions" :value="option">
                                                {{ option }}
                                            </option>
                                        </select>                                
                                        <div class="invalid-feedback" :class="{'d-block': v$.step[2].hearingAidPlacement.$invalid}">Invalid feedback</div>    
                                    </div>

                                </div>                         
                                <div class="col-6">
                                    <div class="form-label">Hearing Aid</div>
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.hearingAidOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[2].hearingAid" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                    <div 
                                        class="invalid-feedback"
                                        :class="{'d-block': v$.step[2].hearingAid.$invalid}"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>      
                            </div>

                            <div class="row mb-3">
                                <div class="col-6">
                                    <div class="form-label">Eyesight / Vision</div>
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.eyesightVisionOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[2].eyesightVision" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                    <div 
                                        class="invalid-feedback"
                                        :class="{'d-block': v$.step[2].eyesightVision.$invalid}"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>                         
                                <div class="col-6">                                    
                                </div>      
                            </div>
                            <div class="row mb-3">
                                <div class="col-6">
                                    <div class="form-label">Restraint / Enabler</div>
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.restraintEnablerOptions" v-if="key <= 3">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[2].restraintEnabler" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>
                                    <div 
                                        class="invalid-feedback"
                                        :class="{'d-block': v$.step[2].restraintEnabler.$invalid}"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>                         
                                <div class="col-6">                                    
                                </div>      
                            </div>

                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">                            

                            <div class="row mb-3">
                                <div class="form-label">Diet / Fluids</div>
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.dietFluidsOptions" v-if="key <= 7">
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[2].dietFluids" />
                                        <span class="form-check-label">{{option}}</span>
                                    </div>                                    
                                </div>                         
                                <div class="col-6">
                                    <div class="form-check form-switch ms-1 mb-2"  v-for="(option,key) in this.dietFluidsOptions" v-if="key > 7">
                                        
                                        <input class="form-check-input" type="checkbox" :value="option" v-model="step[2].dietFluids" />
                                        <span class="form-check-label">{{option}}</span>

                                        <div v-if="option == 'Supplemental Drink' && step[2].dietFluids.indexOf('Supplemental Drink') !== -1" >
                                            <input
                                                type="text"
                                                class="form-control w-100"
                                                name="supplementalDrink"
                                                placeholder="Specify Drink"
                                                v-model="step[2].supplementalDrink"
                                                :class="{
                                                    'is-invalid': v$.step[2].supplementalDrink.$invalid,
                                                }"
                                            />
                                            <div
                                                class="invalid-feedback"
                                                :class="{
                                                    'd-block': v$.step[2].supplementalDrink.$invalid,
                                                }"
                                            >
                                                Invalid feedback
                                            </div>
                                        </div>

                                        <div v-if="option == 'Allergies' && step[2].dietFluids.indexOf('Allergies') !== -1" >
                                            <input
                                                type="text"
                                                class="form-control w-100"
                                                name="allergies"
                                                placeholder="Specify allergies"
                                                v-model="step[2].allergies"
                                                :class="{
                                                    'is-invalid': v$.step[2].allergies.$invalid,
                                                }"
                                            />
                                            <div
                                                class="invalid-feedback"
                                                :class="{
                                                    'd-block': v$.step[2].allergies.$invalid,
                                                }"
                                            >
                                                Invalid feedback
                                            </div>
                                        </div>

                                        <div v-if="option == 'Special Diet' && step[2].dietFluids.indexOf('Special Diet') !== -1" >
                                            <input
                                                type="text"
                                                class="form-control w-100"
                                                name="specialDiet"
                                                placeholder="Specify special diet"
                                                v-model="step[2].specialDiet"
                                                :class="{
                                                    'is-invalid': v$.step[2].specialDiet.$invalid,
                                                }"
                                            />
                                            <div
                                                class="invalid-feedback"
                                                :class="{
                                                    'd-block': v$.step[2].specialDiet.$invalid,
                                                }"
                                            >
                                                Invalid feedback
                                            </div>
                                        </div>


                                    </div>                                    
                                </div>
                                <div 
                                    class="invalid-feedback"
                                    :class="{'d-block': v$.step[2].dietFluids.$invalid}"
                                >
                                    Invalid feedback
                                </div>   
                            </div>

                            <div class="row mb-3">
                                <div class="form-label">Risk/s</div>                     
                                <textarea
                                    rows="5"
                                    class="form-control w-75"
                                    placeholder="Risk/s"
                                    spellcheck="false"
                                    name="risks"
                                    v-model="step[2].risks"
                                    :class="{
                                        'is-invalid': v$.step[2].risks.$invalid,
                                    }"
                                ></textarea>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].risks.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>                            

                            <div class="row mb-3">
                                <div class="form-label">Start date</div>
                                <input
                                    type="date"
                                    class="form-control  w-75"
                                    name="startDate"
                                    placeholder=""
                                    v-model="step[2].startDate"
                                    :class="{'is-invalid': v$.step[2].startDate.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].startDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                    
                            <div class="row mb-3 d-none">
                                <div class="form-label">Next Review (Plan Expiration)</div>
                                <input
                                    type="date"
                                    class="form-control  w-75"
                                    name="expirationDate"
                                    placeholder=""
                                    v-model="step[2].expirationDate"
                                    :class="{'is-invalid': v$.step[2].expirationDate.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].expirationDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="form-label">Signature</div>                     
                                <input
                                    type="text"
                                    class="form-control w-75 mt-2"
                                    name="registeredNurseSignature"
                                    placeholder="Enter your full name"
                                    v-model="step[2].registeredNurseSignature"
                                    :class="{'is-invalid': v$.step[2].registeredNurseSignature.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[2].registeredNurseSignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
                
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn" id="last-save-btn">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack()" href="#" class="p-2 mx-3 d-block back-btn" id="last-back-btn">Back</a>
                        <a @click="onClickNext()" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>                
            </div>                            

        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue, helpers} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import Multiselect from 'vue-multiselect';
import moment from 'moment';

export default {
    name: "initialNursingCarePlanCreateComponent",
    props: ["progressBar", "pageTitle", "residentId", "userId", "carePlan", "operation", "cancelUrl"], // vue can read kebab props as camel cased vars
    components: { Multiselect },
    setup() {
        return {v$: useVuelidate()};
    },
    data() {
       
        // If copying, assign carePlan object to a variable
        if (this.operation == 'store') {
            var carePlanObject = {};                                                      
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + process.env.MIX_API_KEY; 
        }
        else if (this.operation == 'update') {            
            var carePlanObject = JSON.parse(this.carePlan);
            carePlanObject['initial_nursing_care_plan'] = JSON.parse(carePlanObject['initial_nursing_care_plan']);
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + carePlanObject.id + '/' + process.env.MIX_API_KEY; 
        }
        else if (this.operation == 'copy') {
            var carePlanObject = JSON.parse(this.carePlan);
            carePlanObject['initial_nursing_care_plan'] = JSON.parse(carePlanObject['initial_nursing_care_plan']);            
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + process.env.MIX_API_KEY;       
        }

      
        // Returs empty string when object doesn't exist 
        // options - array | string
        function returnValueFromObject(carePlanType = null, fieldName, defaultValue = "") {      
            // Editing
            if (!_.isEmpty(carePlanObject)) { 
                if (carePlanType == null) {
                    if (fieldName == 'starts_at' || fieldName == 'expires_at') {
                        return carePlanObject[fieldName] != null ? carePlanObject[fieldName].split(' ')[0] : defaultValue;
                    } else {
                        return carePlanObject[fieldName] ?? defaultValue;               
                    }
                } else {
                    return carePlanObject[carePlanType][fieldName] ?? defaultValue;
                }
            } else {
                return defaultValue;
            }
        }

  

        return {
            currentStep: 0, // The step[] array starts with 0 (Ex. a 3 step form will have indexes step[0], step[1], step[2])
            maxStep: 3, // maxStep needs to include the extra 'finish step' (Ex. so a 3 step form will have an index step[3] )
            percentageComplete: 0,
            errors: 0,
            trueFalseOptions: [true, false],
            orientationMentalStateOptions: [
                    "Alert / Orientated",
                    "Confused",
                    "Depressed",
                    "Diagnosis of Dementia",
                    "Good",
                    "Impaired Memory",
                    "Inclined to wander",
                ],

            speechCommunicationOptions: [
                    "Good",
                    "Difficult / Limited",
                    "Non - verbal",
                    "Other Language",
                ],

            mobilityOptions: [
                    "Independent",
                    "1 x person assist",
                    "2 x person assist",
                    "Full sling hoist",
                    "Standing hoist",
                    "Low walking frame",
                    "Walking Stick",
                    "Gutter frame",
                    "Wheelchair",
                    "Power chair",
                    "Falls Risk",
                ],

            fallsRiskOptions: [
                    "High",
                    "Medium",
                    "Low / No Risk",
                ],

            hygieneDressingOptions: [
                    "Independent",
                    "Supervision",
                    "1 x person assist",
                    "2 x person assist",
                    "Shower",
                    "Shaving",
                    "Apply make up",                 
                    "Independent Dressing",                 
                    "Some Assistance Dressing",                 
                    "Full Assistance Dressing",                 
                ],

            skinOptions: [
                    "Good",
                    "Abrasions",
                    "Wounds",
                    "Skin tears",
                    "Skin rash",
                    "Pressure Injury",
                    "Special skin treatment",                 
                ],

            painManagementOptions: [
                    "No reported pain",
                    "PRN analgesia",
                    "Regular analgesia",
                    "Reports pain",               
                ],
                
            pressureInjuryRiskOptions: [
                    "Very High Risk",
                    "High Risk",
                    "At Risk",
                    "Pressure Relief Aids",
                    "Pressure Relief Matress",
                    "Roho Cushions",
                    "Regular turns",
                ],
                
            mouthCaresOptions: [
                    "Independent",
                    "Supervision",
                    "Needs Assistance",
                    "1 x day",
                    "2 x day",
                    "3 x day",
                    "2 hourly (Pallative Care)",
                    "Own teeth",
                    "Dentures (top/bottom)",
                    "Partial plate",
                    "Soak dentures",
                ],
                
            groomingFingernailsOptions: [
                    "Independent",
                    "By staff",
                    "By NOK",
                ],
                
            groomingToenailsOptions: [
                    "Podiatrist",
                    "By NOK",
                ],
                
            groomingHairOptions: [
                    "Independent",
                    "By NOK",
                    "Hair dresser",
                    "Special scalp treatment",
                ],
                
            toiletingOptions: [
                    "Independent",
                    "Supervision",
                    "1 x assist",
                    "2 x assist",
                    "Bottle / Uridome",
                    "Incontinence products",
                    "Catheter (SPC / IDC)",
                    "Urine Incontinent",
                    "Faecal Incontinent",
                    "Regular Toileting",
                ],

            sleepingOptions: [
                    "Sleeps Well",
                    "Distrubed Sleep",
                    "PRN / Regular Medication",
                    "Wakes",
                    "Settles",                   
                ],

            breathingRespiratoryOptions: [
                    "No difficulty",
                    "Some difficulty",
                    "Uses inhalers / nebuilisers",
                    "On Oxygen",
                ],
                
            hearingOptions: [
                    "Intact",
                    "Poor",
                    "N/A",
                    "Hearing Aid",
                ],

            hearingAidPlacementOptions: [
                    "Left",
                    "Right",
                    "Both",
                ],

            hearingAidOptions: [
                    "Assistance need to insert",
                    "Battery to be replaced by staff",
                    "To be left with resident",
                    "To be kept in nurse station",
                ],

            eyesightVisionOptions: [
                    "Good",
                    "Poor",
                    "Eye glasses",
                    "Glaucoma / Cataract",
                ],

            restraintEnablerOptions: [
                    "Restraint",
                    "Enabler",
                ],

            dietFluidsOptions: [
                    "Normal diet",
                    "Diabetic diet",
                    "Soft",
                    "Pureed",
                    "Dairy free",
                    "Gluten free",
                    "Vegetarian",
                    "FODMAP",
                    "Supplemental Drink",
                    "Allergies",
                    "Special Diet",
                ],

            host: document.location.origin,
            endpoint: endpointToUse,
            step: [
                // Step 0 - Initial Care Plan Details
                {
                    temp: returnValueFromObject('initial_nursing_care_plan','temp'),
                    pulse:returnValueFromObject('initial_nursing_care_plan','pulse'),
                    resps:returnValueFromObject('initial_nursing_care_plan','resps'),
                    o2sat:returnValueFromObject('initial_nursing_care_plan','o2sat'),
                    bp:returnValueFromObject('initial_nursing_care_plan','bp'),
                    weight:returnValueFromObject('initial_nursing_care_plan','weight'),
                    bsl:returnValueFromObject('initial_nursing_care_plan','bsl'),
                    orientationMentalState:returnValueFromObject('initial_nursing_care_plan','orientationMentalState', []),
                    speechCommunication:returnValueFromObject('initial_nursing_care_plan','speechCommunication',[]),
                    speechCommunicationPrimaryLanguage:returnValueFromObject('initial_nursing_care_plan','speechCommunicationPrimaryLanguage'),
                    speechCommunicationSecondaryLanguage:returnValueFromObject('initial_nursing_care_plan','speechCommunicationSecondaryLanguage'),
                    mobility:returnValueFromObject('initial_nursing_care_plan','mobility',[]),
                    fallsRisk:returnValueFromObject('initial_nursing_care_plan','fallsRisk'),
                    hygieneDressing:returnValueFromObject('initial_nursing_care_plan','hygieneDressing',[]),
                    showerFrequency:returnValueFromObject('initial_nursing_care_plan','showerFrequency'),
                    skin:returnValueFromObject('initial_nursing_care_plan','skin',[]),
                    
                    
                },
         
                // Step 1 - Plan Information
                {
                    painManagement:returnValueFromObject('initial_nursing_care_plan','painManagement',[]),        
                    pressureInjuryRisk:returnValueFromObject('initial_nursing_care_plan','pressureInjuryRisk',[]),        
                    turnsFrequency:returnValueFromObject('initial_nursing_care_plan','turnsFrequency'),                  
                    mouthCares:returnValueFromObject('initial_nursing_care_plan','mouthCares',[]),        
                    soakDenturesFrequency:returnValueFromObject('initial_nursing_care_plan','soakDenturesFrequency'),                  
                    groomingFingernails:returnValueFromObject('initial_nursing_care_plan','groomingFingernails',[]),        
                    groomingToenails:returnValueFromObject('initial_nursing_care_plan','groomingToenails',[]),        
                    groomingHair:returnValueFromObject('initial_nursing_care_plan','groomingHair',[]),  
                    toileting:returnValueFromObject('initial_nursing_care_plan','toileting',[]),
                    catheterEmptyingFrequency:returnValueFromObject('initial_nursing_care_plan','catheterEmptyingFrequency'),                  
                    toiletingFrequency:returnValueFromObject('initial_nursing_care_plan','toiletingFrequency',""),                  
                    sleeping:returnValueFromObject('initial_nursing_care_plan','sleeping',[]),
                    wakes:returnValueFromObject('initial_nursing_care_plan','wakes'),                  
                    settles:returnValueFromObject('initial_nursing_care_plan','settles'),                   
                },
                
                // Step 2 - Initial Care Plan Details
                {
                    breathingRespiratory:returnValueFromObject('initial_nursing_care_plan','breathingRespiratory',[]),
                    breathingDifficultyDescription:returnValueFromObject('initial_nursing_care_plan','breathingDifficultyDescription'),                  
                    hearing:returnValueFromObject('initial_nursing_care_plan','hearing',[]),
                    hearingAidPlacement:returnValueFromObject('initial_nursing_care_plan','hearingAidPlacement'),
                    hearingAid:returnValueFromObject('initial_nursing_care_plan','hearingAid',[]),
                    eyesightVision:returnValueFromObject('initial_nursing_care_plan','eyesightVision',[]),
                    restraintEnabler:returnValueFromObject('initial_nursing_care_plan','restraintEnabler',[]),
                    dietFluids:returnValueFromObject('initial_nursing_care_plan','dietFluids',[]),                    
                    supplementalDrink:returnValueFromObject('initial_nursing_care_plan','supplementalDrink'),
                    allergies:returnValueFromObject('initial_nursing_care_plan','allergies'),
                    specialDiet:returnValueFromObject('initial_nursing_care_plan','specialDiet'),
                    risks:returnValueFromObject('initial_nursing_care_plan','risks'),
                    startDate:returnValueFromObject(null,'starts_at'),
                    expirationDate:returnValueFromObject(null,'expires_at'),
                    registeredNurseSignature:returnValueFromObject(null,'registered_nurse_signature'),                  
                },

                // 'Finish' Step 
                {}
            ],
            api_token: process.env.MIX_API_KEY,
        };
    },
    validations() {
        // Custom Validators
        const inArray = (array) => (value) => array.includes(value) || !helpers.req(value);
        const isDateFormat = (value) => value.match("^$|((?:[0-9]{2})?[0-9]{2})-(1[0-2]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])") || !helpers.req(value);
        const isTimeFormat = (value) => value.match("^$|^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$") || !helpers.req(value);
        const isTextWithSpecialCharacters = (value) => value.match("^[a-zA-Z0-9_ !@#$&%^*()`.+,/\\-\r\n\s\'\"]*$") || !helpers.req(value);
        const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ \s\'\"]*$") || !helpers.req(value);

        const dateType = {
            required, 
            isDateFormat, 
            $lazy: true, 
            $autoDirty: true
        };
        
        const timeType = {
            required, 
            isTimeFormat, 
            $lazy: true, 
            $autoDirty: true
        };

        // TEXT TYPES: default: 191, mid:500, long:1000
        function text(minimum = 3,maximum = 191, isRequired = false, allowSpecial = false) {
            if (allowSpecial) {
                var rule = {
                    required,
                    isTextWithSpecialCharacters,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };
            } else {
                var rule = {
                    required,
                    isTextWithSpace,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };                
            }

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }

        // ARRAY TYPES        
        function inOptions(options, isRequired = false) {
            var rule = {
                required,
                inOptions: inArray(options),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }
        
        // Use for types with no 'required' parameter
        function notRequired(type) {
            var validations = Object.assign({}, type);                
            delete validations['required'];
            
            return validations;
        };

        return {
            step: [
                // Step 0 - Intervention 1
                {
                    temp: text(1,500,false,true),
                    pulse: text(1,500,false,true),
                    resps: text(1,500,false,true),
                    o2sat: text(1,500,false,true),
                    bp: text(1,500,false,true),
                    weight: text(1,500,false,true),
                    bsl: text(1,500,false,true),
                    orientationMentalState: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    speechCommunication: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    speechCommunicationPrimaryLanguage: text(3,100,false,true),
                    speechCommunicationSecondaryLanguage: text(3,100,false,true),
                    mobility: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    fallsRisk: inOptions(this.fallsRiskOptions),
                    hygieneDressing: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    showerFrequency: inOptions(this.fallsRiskOptions),
                    skin: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                },
     
                // Step 1 - Plan Information
                {   
                    painManagement: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    pressureInjuryRisk: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    turnsFrequency: text(),
                    mouthCares: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    soakDenturesFrequency: text(),
                    groomingFingernails: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    groomingToenails: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    groomingHair: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    toileting: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    catheterEmptyingFrequency: text(),
                    toiletingFrequency: text(),
                    sleeping: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    wakes: notRequired(timeType),
                    settles: notRequired(timeType),           
                },

                // Step 2 - Plan Information
                {
                    breathingRespiratory: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    breathingDifficultyDescription: text(),
                    hearing: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    hearingAidPlacement: inOptions(this.hearingAidPlacementOptions),
                    hearingAid: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    eyesightVision: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    restraintEnabler: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    dietFluids: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    supplementalDrink: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    allergies: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    specialDiet: { // @TODO: validate each value in the array
                        $lazy: true,
                        $autoDirty: true,
                    },
                    risks: text(3,500, false, true),
                    startDate: dateType,
                    expirationDate: notRequired(dateType),
                    registeredNurseSignature: text(3, 191, true, true)
                },

                // 'Finish' Step 
                {}
            ],
        };
    },

    computed: {},

    methods: {
        onClickNext: function () {
            // Validate fields on current step
            this.v$.step[this.currentStep].$touch();

            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep].$error) {                
                // All steps
                if (this.currentStep < this.maxStep - 1) {  // -1 because we don't need the 'finish step' here
                    // Proceed to next step
                    this.currentStep++;

                // Final step
                } else if (this.currentStep == this.maxStep - 1) { // -1 because we don't need the 'finish step' here
                    
                    // Initialize alerts and toast notifications for displaying message  
                    const toastError = Swal.mixin({          
                            toast: true,                
                            position: 'top-end', 
                            showConfirmButton: true, 
                        });  
                    const alertSuccess = Swal.mixin({                          
                            position: 'center', 
                            showConfirmButton: true, 
                            timer: 3000,
                            timerProgressBar: true,
                        });  

                    // Show button spinner
                    document.getElementById('submit-btn').innerHTML  = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById('submit-btn').disabled  = true;
                    document.getElementById('last-back-btn').setAttribute('style', 'display:none !important');
                    
                    var now = moment().format('DD/MM/YYYY');
                    var formData = {};
                    
                    // Loop through all steps
                    for(let i=0; i < this.maxStep; i++){                                        
                        for (const [key,value] of Object.entries(this.step[i])) {   
                            formData[key] = value;                     
                        }
                    }

                    // Add residentID and userID
                    formData['residentID'] = this.residentId;
                    formData['userID'] = this.userId;
                    formData['type'] = "Initial Nursing";
                    

                    if (this.operation == 'store' || this.operation == 'copy') {
                        this.createCarePlan(formData, toastError, alertSuccess);
                    }
                    else if(this.operation == 'update') {
                        formData['updateType'] = 'update';
                        this.updateCarePlan(formData, toastError, alertSuccess);
                    }
                }                
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100); 
            }
        },
        onClickBack: function () {
            if (this.currentStep > 0) {
                this.currentStep--;
            }
            else {
                window.location = this.cancelUrl;
            }
            this.percentageComplete = Math.round((this.currentStep/ this.maxStep) * 100);
        },

        createCarePlan: function(formData, toastError, alertSuccess) {            
            // Call the store endpoint
            axios.post(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            }); 
                            
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was added to the DB. Thi
                            this.formSuccess = true;
                            window.residentId = this.residentId; 

                            alertSuccess.fire({
                                title: "Success!",
                                text: "The initial nursing care plan has been added.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/residents/"+window.residentId+"/care-plans?type=Initial+Nursing";
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'warning', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        },

        updateCarePlan: function(formData, toastError, alertSuccess) {
            
            // Call the update endpoint
            axios.put(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            });                             
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was updated
                            this.formSuccess = true;
                            window.residentId = this.residentId;

                            alertSuccess.fire({
                                title: "Success!",
                                text: "The initial nursing care plan has been updated.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/residents/"+window.residentId+"/care-plans?type=Initial+Nursing";
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'error', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        }        
        
    },
};
</script>
